import {issuePolicy} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as A from 'ApplicationEntry/ducks/application';
import * as M from 'ApplicationEntry/ducks/messages';
import {push} from 'connected-react-router';
import {createSnackbar} from 'Core/ducks/snackbar';
import {Loaded} from 'Core/models/Async';
import {all, call, put, takeEvery, takeLatest} from 'redux-saga/effects';

type responseModel = {
  status: number;
  data: IssuePolicyResponseModel;
};

type IssuePolicyResponseModel = {
  status: string;
  messages: object[];
};

function* issuePolicySaga() {
  let messagesObject: object[] = [];

  yield takeEvery(A.ApplicationActionType.ISSUE_POLICY_QUALITY, function*(action: ReturnType<typeof A.issuePolicy>) {
    const {payload} = action;
    const {policyNumber} = payload;

    const response: responseModel = yield call(issuePolicy, policyNumber);

    if (response?.status === 202) {
      messagesObject.push(...response.data.messages);
      yield put(M.changeLife70ErrorMessage(new Loaded(messagesObject)));
      yield all([put(createSnackbar('Policy issued successfully!'))]);
    } else if (response?.status === 400) {
      if (messagesObject?.length === 0) {
        messagesObject.push(...response.data.messages);
      }
      let result = messagesObject?.map(message => {
        let msgPresentInMessagesObject: object | undefined = {};
        if (message['classifications']['life_70_code']) {
          msgPresentInMessagesObject = response.data.messages?.find(
            message2 =>
              message['classifications']['policy_number'] === message2['classifications']['policy_number'] &&
              message['classifications']['life_70_code'] === message2['classifications']['life_70_code']
          );
          if (!msgPresentInMessagesObject) {
            msgPresentInMessagesObject = response.data.messages?.find(
              message2 =>
                message['classifications']['policy_number'] === message2['classifications']['policy_number'] &&
                message2['classifications']['life_70_code'] === 'M'
            );
          }
        } else {
          msgPresentInMessagesObject = response.data.messages?.find(
            message2 =>
              message['classifications']['policy_number'] === message2['classifications']['policy_number'] &&
              message['category'] === message2['category'] &&
              message['message'] !== message2['message']
          );
        }

        let msgPresent = false;
        if (msgPresentInMessagesObject) {
          msgPresent = messagesObject.some(msg => msg['message'] == msgPresentInMessagesObject!['message']);
        }
        if (msgPresent === false) {
          message['message'] = msgPresentInMessagesObject ? msgPresentInMessagesObject['message'] : message['message'];
          message['responseSeverity'] = msgPresentInMessagesObject
            ? msgPresentInMessagesObject['responseSeverity']
            : message['responseSeverity'];
          message['classifications']['life_70_code'] = msgPresentInMessagesObject
            ? msgPresentInMessagesObject['classifications']['life_70_code']
            : message['classifications']['life_70_code'];
        }

        return message;
      });

      yield put(M.changeLife70ErrorMessage(new Loaded(messagesObject)));
    } else if (response.status === 401 || response.status === 403) {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield all([put(createSnackbar('Failed to issue policy!'))]);
    }
  });
}

export default function*() {
  yield all([issuePolicySaga()]);
}
